// Libraries
import { Grid } from "@mui/material";

// Types
import { ILot } from "@/Settings/types/administrationTools/model";

// Components
import LotAreaSkeleton from "./LotAreaSkeleton";
import LotItem from "./LotItem";

type TLotAreaProps = {
	lots: ILot[];
	isLoading: boolean;
	removeLot: (lotKey: string) => void;
	deletingLotId?: string | null;
};

export default function LotArea(props: Readonly<TLotAreaProps>) {
	const { lots, isLoading, removeLot, deletingLotId } = props;
	if (isLoading) {
		return <LotAreaSkeleton />;
	}

	if (!lots?.length) {
		return null;
	}

	return (
		<Grid container className="!gap-8  mt-8">
			{lots
				.filter((lot) => lot?.points?.length > 0)
				.map((lot) => (
					<LotItem key={lot._id} {...lot} removeLot={removeLot} isDeleting={deletingLotId === lot._id} />
				))}
		</Grid>
	);
}
